import type { Group, State } from './types';

export type Mutation =
  | {
      type: 'setGroups';
      data: Group[];
      campus?: string | string[];
    }
  | { type: 'addGroup'; item: Group }
  | { type: 'updateGroup'; item: Group };

export function reducer(state: State, action: Mutation): State {
  switch (action.type) {
    case 'setGroups':
      return setGroups(state, action);
    case 'addGroup':
      return addGroup(state, action);
    case 'updateGroup':
      return updateGroup(state, action);
    default:
      return state;
  }
}

function setGroups(
  state: State,
  { data, campus }: { data: Group[]; campus?: string | string[] },
): State {
  let allLoaded = false;
  const campusLoaded = state.campusLoaded || new Set<string>();
  if (!campus) {
    allLoaded = true;
  } else if (Array.isArray(campus)) {
    campus.forEach((item) => campusLoaded.add(item));
  } else {
    campusLoaded.add(campus);
  }

  return {
    data,
    allLoaded,
    campusLoaded,
  };
}

function addGroup(state: State, { item }: { item: Group }): State {
  return {
    ...state,
    data: [...state.data, item],
  };
}

function updateGroup(state: State, { item }: { item: Group }): State {
  const id = item.id;
  const i = state.data.findIndex((item) => item.id === id);
  const data = [...state.data];
  data[i] = {
    id,
    data: {
      ...data[i].data,
      ...item.data,
    },
  };

  return {
    ...state,
    data,
  };
}
